import React, { useEffect, useState } from 'react';
import AxiosInstance from '../../helper/AxiosInstance'
import { showDate } from '../../helper/function'
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from './Header';
export default function PaymentSuccess() {
    const { transactionId } = useParams();
    const [data, setdata] = useState();
    const fatchTran = async() => {
        try{
            const response = await AxiosInstance.get(`/public/transaction/${transactionId}`);
            if (response.status === 1) { setdata(response.data) }
        }catch(err){

        }
    }
    useEffect(() => { fatchTran() }, []);
    return (
        <>
            <Helmet>
                <title>Payment Success | Taskflier </title>
             </Helmet>
                <div
                    id="resources"
                    class="fancy-feature-fortySix lg-container pt-40 lg-mt-100 pt-40 pb-150 md-pt-80 lg-pb-80"
                >
                    <div class="container position-relative">


                        <div class="row justify-content-center">
                            <div class="col-lg-5 col-md-5 d-flex ">
                                <div class="block-style-five">
                                    <div class="title-style-seven text-center">
                                        
                                        <div className='status text-center'><span className='bg-success'><i class="bi bi-check2"></i></span></div>
                                        <h2 className='payment-head'>
                                            Payment <span>{data?.orderStatus ?? ''}</span>
                                        </h2>
                                        <p className='infor'>
                                            Dear User, Thanks for choosing TaskFlier, We are sending your ID Password to your mail ID after <b>30 minutes.</b>
                                        </p>
                                        <hr></hr>

                                        <ul class="list-group mt-3 payment-list">
                                            <li class="list-group-item font-14 d-flex justify-content-between align-items-center">
                                                Transaction ID
                                                <span class="text-primary ">{data?.orderID ?? ''}</span>
                                            </li>
                                            <li class="list-group-item font-14 d-flex justify-content-between align-items-center">
                                                Date & Time
                                                <span class="text-primary ">{showDate(data?.transDate, 'd m y h:sa')}</span>
                                            </li>
                                            <li class="list-group-item font-14 d-flex justify-content-between align-items-center">
                                                Plan
                                                <span class="text-primary ">{data?.package?.plan ?? ''}</span>
                                            </li>
                                            {
                                                data?.merAmount ?
                                                    <li class="list-group-item font-14 d-flex justify-content-between align-items-center">
                                                        Amount
                                                        <span class="text-primary ">{data?.amount ? (data.amount/100).toFixed(2) : 'Free Trial'}</span>
                                                    </li> : ""
                                            }
                                        </ul>


                                        <Link class="btn btn-lg  btn-primary mt-4 w-100" to="/">Back To Home </Link>
                                    </div>

                                </div>
                            </div>

                        </div>





                    </div>
                    <img
                        src="/main/images/shape/246.svg"
                        alt=""
                        class="shapes shape-one"
                    />
                    <img
                        src="/main/images/shape/247.svg"
                        alt=""
                        class="shapes shape-two"
                    />
                    <img
                        src="/main/images/shape/248.svg"
                        alt=""
                        class="shapes shape-three"
                    />
                    <img
                        src="/main/images/shape/249.svg"
                        alt=""
                        class="shapes shape-four"
                    />
                </div>






                <div className="footer-bg-wrapper bg-white">
                    <div className="bubble-one" />
                    <div className="bubble-two" />
                    <div className="bubble-three" />
                    <div className="fancy-short-banner-two">
                        <div className="container">
                            <div className="content-wrapper">
                                <div className="bg-wrapper d-lg-flex align-items-center justify-content-between">
                                    <h2>Still Having a Doubt? Clear Them With a Free Demo.</h2>
                                    <a
                                        href="https://taskflier.com/#"
                                        data-toggle="modal"
                                        data-target="#contactModal"
                                    >
                                        Request Demo
                                    </a>
                                    <div className="bubble-one" />
                                    <div className="bubble-two" />
                                    <div className="bubble-three" />
                                    <div className="bubble-four" />
                                    <div className="bubble-five" />
                                </div>{" "}
                                {/* /.bg-wrapper */}
                            </div>{" "}
                            {/* /.content-wrapper */}
                        </div>{" "}
                        {/* /.container */}
                    </div>{" "}
                    {/* /.fancy-short-banner-two */}
                    <footer class="theme-footer-one pt-130 md-pt-70">
                        <div class="top-footer">
                            <div class="container">
                                <div class="row justify-content-end">
                                    <div
                                        class="col-lg-3 col-md-12 footer-about-widget aos-init aos-animate"
                                        data-aos="fade-up"
                                        data-aos-duration="1200"
                                    >
                                        <a href="index.html" class="logo">
                                            <img src="/main/images/logo/mnb-project.png" alt="" />
                                        </a>
                                    </div>
                                    <div
                                        class="col-lg-3 col-md-4 footer-list aos-init aos-animate"
                                        data-aos="fade-up"
                                        data-aos-duration="1200"
                                        data-aos-delay="50"
                                    >
                                        <h5 class="footer-title">Features</h5>
                                        <ul>
                                            <li>
                                                <a href="#">Projects </a>
                                            </li>
                                            <li>
                                                <a href="#">Employee </a>
                                            </li>
                                            <li>
                                                <a href="#">Clients </a>
                                            </li>
                                            <li>
                                                <a href="#">Tickets </a>
                                            </li>
                                            <li>
                                                <a href="#">Appointments </a>
                                            </li>
                                            <li>
                                                <a href="#">Resource</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div
                                        class="col-lg-3 col-md-4 footer-list aos-init aos-animate"
                                        data-aos="fade-up"
                                        data-aos-duration="1200"
                                        data-aos-delay="100"
                                    >
                                        <h5 class="footer-title">Resources</h5>
                                        <ul>
                                            <li>
                                                <a href="#">Help Desk</a>
                                            </li>
                                            <li>
                                                <a href="#">Auto Message</a>
                                            </li>
                                            <li>
                                                <a href="#">Auto Message</a>
                                            </li>
                                            <li>
                                                <a href="#">Analytic Report</a>
                                            </li>
                                            <li>
                                                <a href="#">Add Leads</a>
                                            </li>
                                            <li>
                                                <a href="#">Data Security</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div
                                        class="col-lg-3 col-md-4 address-list aos-init aos-animate"
                                        data-aos="fade-up"
                                        data-aos-duration="1200"
                                        data-aos-delay="150"
                                    >
                                        <h5 class="footer-title">Address</h5>
                                        <ul>
                                            <li>
                                                <a href="#">support@taskflier.com</a>
                                            </li>
                                            <li>
                                                <Link to="#" class="mobile-num">
                                                    +91 99946 57491
                                                </Link>
                                            </li>
                                            <li>
                                                5th Block, 1217, Chord Rd, Near Shivanagar Signal, Rajajinagar, Bengaluru, Karnataka 560010
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="container">
                            <div class="bottom-footer-content">
                                <div class="d-sm-flex align-items-center justify-content-between">
                                    <ul
                                        class="order-sm-last aos-init aos-animate"
                                        data-aos="fade-left"
                                        data-aos-duration="1200"
                                        data-aos-delay="100"
                                        data-aos-anchor=".theme-footer-one"
                                    >
                                        <li>
                                            <a href="#">Privacy</a>
                                        </li>
                                        <li>
                                            <a href="#">Security</a>
                                        </li>
                                        <li>
                                            <a href="#">Terms</a>
                                        </li>
                                    </ul>
                                    <p
                                        class="order-sm-first aos-init aos-animate"
                                        data-aos="fade-right"
                                        data-aos-duration="1200"
                                        data-aos-delay="100"
                                        data-aos-anchor=".theme-footer-one"
                                    >
                                        Copyright @2024 MNB Project.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </footer>
                    {/* /.theme-footer-one */}
                </div>
                <div
                    className="modal fade modal-contact-popup-one"
                    id="contactModal"
                    tabIndex={-1}
                    role="dialog"
                    aria-labelledby="contactModalTitle"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <main className="main-body modal-content clearfix">
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <img src="./HomePage_files/close.svg" alt="" />
                            </button>
                            <div className="right-side">
                                <p className="form-pre">Safe &amp; Confidential</p>
                                <h2 className="form-title">Request For a Free Demo</h2>
                                <form className="submitrequest">
                                    <div className="messages" />
                                    <div className="row controls">
                                        <div className="col-12">
                                            <div className="input-group-meta form-group mb-15">
                                                <label>Name</label>
                                                <input
                                                    type="text"
                                                    placeholder="Your Name"
                                                    name="Fname"
                                                    id="name"
                                                    required="required"
                                                    data-error="Name is required."
                                                />
                                                <div className="help-block with-errors" />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="input-group-meta form-group mb-15">
                                                <label>Email*</label>
                                                <input
                                                    type="email"
                                                    placeholder="Email Address"
                                                    name="email"
                                                    id="email"
                                                    required="required"
                                                    data-error="Valid email is required."
                                                />
                                                <div className="help-block with-errors" />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="input-group-meta form-group mb-15">
                                                <label>Phone*</label>
                                                <input
                                                    type="number"
                                                    placeholder="Phone No."
                                                    name="phone"
                                                    id="phone"
                                                    required="required"
                                                    data-error="Valid phone no. is required."
                                                />
                                                <div className="help-block with-errors" />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="input-group-meta form-group mb-35">
                                                <label>Apply For*</label>
                                                <select
                                                    name="Subject"
                                                    data-error="Valid Category is required."
                                                    id="subject"
                                                >
                                                    <option value="">-- Select Services --</option>
                                                    <option>IT Services</option>
                                                    <option>Charted Accountant</option>
                                                    <option>Commerce</option>
                                                    <option>Construction</option>
                                                    <option>Textiles</option>
                                                    <option>Electrical</option>
                                                </select>
                                                <div className="help-block with-errors" />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <button className="theme-btn-seven w-100">
                                                Send Message
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </main>
                    </div>
                </div>

        </>

    );
}
